// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1rCat","footer":"ModalFilter_footer__20j5N"};